import { StateService } from '@uirouter/core';
import { SessionService } from '@monsido/core/session/session.service';

export const isCustomerAdminResolver = () => {
    return {
        token: 'isCustomerAdmin',
        deps: [StateService, SessionService],
        resolveFn: async (
            stateService: StateService,
            sessionService: SessionService,
        ): Promise<boolean> => {
            const { customer, roles } = sessionService;
            if (!customer || !roles.includes('customer_admin')) {
                stateService.go('base.dashboard');
                return false;
            }

            return true;
        },
    };
};
